import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffc107",
			d: "M43.6 20.1H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8A12 12 0 1 1 32 15l5.7-5.7A20 20 0 1 0 43.6 20.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff3d00",
			d: "m6.3 14.7 6.6 4.8A12 12 0 0 1 32 15l5.7-5.7A20 20 0 0 0 6.3 14.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4caf50",
			d: "M24 44a20 20 0 0 0 13.4-5.2l-6.2-5.2A12 12 0 0 1 12.7 28l-6.5 5A20 20 0 0 0 24 44"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1976d2",
			d: "M43.6 20.1H42V20H24v8h11.3a12 12 0 0 1-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24q0-2.1-.4-3.9"
		})
	]
});
export default SvgGoogleRegularIcon;
